module.exports = __webpack_public_path__ + "img/2024-2.69d17d7f.jpg";